<template>
  <!-- 此处为入口 公共部分可以放到这里 -->
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
    Headers
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#app
  font-family PingFang-SC-Medium, 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
  padding 0
  margin 0
  height 100%
</style>



// WEBPACK FOOTER //
// src/App.vue